import { render, staticRenderFns } from "./NetworkStatusBadge.vue?vue&type=template&id=713410af&scoped=true&"
import script from "./NetworkStatusBadge.vue?vue&type=script&lang=js&"
export * from "./NetworkStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./NetworkStatusBadge.vue?vue&type=style&index=0&id=713410af&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713410af",
  null
  
)

export default component.exports